import React from "react"
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js"
import { Pie } from "react-chartjs-2"
import PropTypes from "prop-types"
import ChartDataLabels from "chartjs-plugin-datalabels"

ChartJS.register(ChartDataLabels, ArcElement, Tooltip, Legend)

/**
 * Rnder the curation outcomes (accepted, decline, etc) for observations over as period as a pie chart
 * @param curationResults
 * @returns {JSX.Element}
 * @constructor
 */
const CurationOutcomesPie = ({ curationResults = {} }) => {
  if (curationResults == null) {
    return null
  }
  const dataset = {
    data: {
      labels: Object.keys(curationResults),
      datasets: [
        {
          label: "count",
          data: Object.values(curationResults),
          backgroundColor: [
            "rgba(50,205,50, 0.2)",
            "rgba(255, 99, 132, 0.2)",
            "rgba(54, 162, 235, 0.2)",
          ],
          borderColor: [
            "rgba(50,205,50, 1)",
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
          ],
          borderWidth: 1,
        },
      ],
    },
    options: {
      plugins: {
        title: {
          display: true,
          text: "Curation outcomes",
        },
      },
    },
  }

  return <Pie data={dataset.data} options={dataset.options} />
}

CurationOutcomesPie.propTypes = {
  curationResults: PropTypes.object,
}

export default CurationOutcomesPie
